<template>
  <div>
    <NotificationReminderContainer
      :reports="reports"
      :feature-name="NOTIFICATION_FEATURES_NAME.EXAM_PLANNER"
    />
  </div>
</template>

<script>
import NotificationReminderContainer from '@/src/components/Settings/notifications/NotificationReminderContainer.vue'
import NOTIFICATION_FEATURES_NAME from '@src/constants/notification-constants.js'
export default {
  components: {
    NotificationReminderContainer,
  },
  page: {
    title: 'Notification | Exam Planner',
    meta: [
      {
        name: 'description',
        content: 'Exam Planner Notification System',
      },
    ],
  },
  data() {
    return {
      NOTIFICATION_FEATURES_NAME,
      reports: ['monthly'],
    }
  },
}
</script>
